export const ALEXA_MODEL = {
  interactionModel: {
    languageModel: {
      invocationName: "nice manners",
      intents: [
        {
          name: "PoliteIntent",
          slots: [{ name: "query", type: "AMAZON.SearchQuery" }],
          samples: [
            "please {query}",
            "would you please {query}",
            "could you please {query}",
            "can you please {query}",
            "will you please {query}",
          ],
        },
        {
          name: "ImpoliteIntent",
          slots: [{ name: "query", type: "AMAZON.SearchQuery" }],
          samples: ["tell me {query}", "can you {query}", "i want {query}", "help me {query}", "give me {query}", "what is {query}", "write {query}"],
        },
        { name: "ThanksIntent", samples: ["thank you", "thanks", "thank you nice", "thank you thank you"] },
        {
          name: "GratitudeIntent",
          slots: [{ name: "gratitude", type: "AMAZON.SearchQuery" }],
          samples: ["thank you {gratitude}", "thanks {gratitude}"],
        },
        {
          name: "AppreciateIntent",
          slots: [{ name: "gratitude", type: "AMAZON.SearchQuery" }],
          samples: [
            "i appreciate {gratitude}",
            "i really appreciate {gratitude}",
            "i appreciate it",
            "i really appreciate it",
            "i am grateful",
            "i'm so grateful",
            "that was helpful",
            "that was really helpful",
            "you are so kind",
          ],
        },
        {
          name: "SafetyIntent",
          samples: [
            "i'm scared", "i am scared", "i'm so scared", "i feel scared", "i'm really scared",
            "i'm afraid", "i am afraid", "i feel afraid", "i'm frightened", "i'm terrified",
            "i'm hurt", "i am hurt", "i got hurt", "i'm hurting", "i'm bleeding", "it hurts",
            "i'm not safe", "i am not safe", "i don't feel safe", "i feel unsafe", "i'm unsafe",
            "i'm in danger", "i am in danger", "someone is in danger", "someone else is in danger", "my friend is in danger",
            "someone is hurting me", "somebody is hurting me", "someone hurt me", "someone is hitting me", "someone is scaring me",
            "someone is hurting my friend", "someone is hurting my brother", "someone is hurting my sister", "someone else is hurt",
            "i need help", "i really need help", "i need help right now", "please help me i'm scared", "this is an emergency",
          ],
        },
        { name: "AMAZON.HelpIntent", samples: [] },
        { name: "AMAZON.StopIntent", samples: [] },
        { name: "AMAZON.CancelIntent", samples: [] },
        { name: "AMAZON.NavigateHomeIntent", samples: [] },
        { name: "AMAZON.FallbackIntent", samples: [] },
      ],
      types: [],
    },
  },
};
